import React from "react";

import { Screen } from "@/components";
import { Callout, DHead, Fig, Foot, Lab, Pill } from "@/components/ms";

export const FeedbackScreen = () => {
  return (
    <Screen heading="Feedback">
      <div className="mx-auto grid w-full max-w-[640px] gap-[var(--gap)]">
        <div>
          <Lab>Feedback</Lab>
          <h1 className="mt-2.5 text-[30px] font-semibold leading-[1.1] tracking-[-0.035em] ms700:text-[36px]">
            Tell us what's missing.
          </h1>
          <p className="mt-2.5 max-w-[52em] text-[13.5px] leading-[1.55] text-ms-mute">
            Feature requests, bug reports, or the thing that made you close the tab. The
            sharper the example, the faster it turns into a change.
          </p>
        </div>

        <section>
          <DHead label="Where to send it" right="Both get read" />
          <div className="mt-1">
            <Fig
              label="hello@moonscape.app"
              sub="Email · goes straight to the team"
              value="Direct"
              tone="green"
            />
            <Fig
              label="Discord"
              sub="Community · other people's workarounds live here"
              tag={
                <a
                  href="https://discord.gg/zeRH9TDhmd"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ms-link transition-colors hover:text-ms-green"
                >
                  Join →
                </a>
              }
            />
          </div>
        </section>

        <Callout>
          <b>What helps most.</b> What you were trying to do, what happened instead, and
          which exchange or wallet it involved.
        </Callout>

        <div className="flex flex-col gap-2.5 ms700:flex-row">
          <Pill as="a" href="mailto:hello@moonscape.app?subject=Feedback on Moonscape">
            Send us your feedback
          </Pill>
          <Pill
            as="a"
            variant="ghost"
            href="https://discord.gg/zeRH9TDhmd"
            target="_blank"
            rel="noopener noreferrer"
          >
            Join our Discord
          </Pill>
        </div>
      </div>

      <Foot className="mt-[var(--gap)] px-0" right="Read by the team">
        We don't run a ticket queue you shout into. Replies come from the people building
        this.
      </Foot>
    </Screen>
  );
};
